import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class IconStylingModel extends CoreStylingModel {
/**
 * StylingModel for original icon
 */
icon?: StylingModel;
/**
 * Object for styling of toggle icon
 */
toggleIcon?: {
    /**
     * StylingModel for toggle icon containe
     */
    container?: StylingModel;
    /**
     * StylingModel for toggle icon element
     */
    icon?: StylingModel;
  }
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function IconStylingModel_tsickle_Closure_declarations() {
/**
 * StylingModel for original icon
 * @type {?}
 */
IconStylingModel.prototype.icon;
/**
 * Object for styling of toggle icon
 * @type {?}
 */
IconStylingModel.prototype.toggleIcon;
}

